import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d384181c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-start" }
const _hoisted_2 = {
  key: 0,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-2 mb-1" }, "Lemondási feltételek", -1))
const _hoisted_4 = { class: "text-body-2 text-medium-emphasis cancellation-policy-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-2 mb-1" }, "Megjegyzés", -1))
const _hoisted_6 = { class: "text-body-2 text-medium-emphasis cancellation-policy-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, { class: "v-card--variant-outlined" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_data_table, {
          items: _ctx.offer.items,
          headers: _ctx.headers,
          "hide-default-footer": true,
          hover: ""
        }, {
          "item.retailPrice": _withCtx(({ value }) => [
            _createTextVNode(_toDisplayString(_ctx.formatPrice(value)), 1)
          ]),
          "item.outgoingGrossPerPersonPerNight": _withCtx(({ value }) => [
            _createTextVNode(_toDisplayString(_ctx.formatPrice(value)), 1)
          ]),
          "item.accommodation": _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", null, _toDisplayString(item.accommodation), 1),
              (_ctx.formatLocation(item.city, item.address))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.formatLocation(item.city, item.address)), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          top: _withCtx(() => [
            _createVNode(_component_v_toolbar, {
              flat: "",
              height: "56",
              color: "transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar_title, { class: "text-left" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(`Ajánlat ${_ctx.offer.items[0]?.accommodation} szálláshelyre`), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_chip, {
                  class: "mr-2",
                  color: _ctx.statusColor,
                  variant: "flat",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.offerStatusLabel(_ctx.offer.status)), 1)
                  ]),
                  _: 1
                }, 8, ["color"]),
                (_ctx.declinable)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "mr-2",
                      color: "error",
                      variant: "text",
                      size: "small",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDeclineConfirm = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Elutasítás")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.acceptable)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 1,
                      bottom: ""
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                          _createVNode(_component_v_btn, {
                            color: "success",
                            variant: "flat",
                            size: "small",
                            disabled: true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Ajánlat elfogadása")
                            ]),
                            _: 1
                          })
                        ], 16)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.blockedReason), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_btn, {
                      key: 2,
                      color: "success",
                      variant: "flat",
                      size: "small",
                      disabled: false,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openConfirm(_ctx.offer.id)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ajánlat elfogadása")
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["items", "headers"]),
        (_ctx.isInvalidated)
          ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_alert, {
                  type: "warning",
                  variant: "tonal",
                  density: "compact"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Az igény módosult, az ajánlat érvénytelenné vált. Az új igényre hamarosan új ajánlat érkezik.")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isRejected)
          ? (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_alert, {
                  type: "info",
                  variant: "tonal",
                  density: "compact"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ezt az ajánlatot elutasították. A többi ajánlat továbbra is elfogadható.")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.offer.cancellationPolicy)
          ? (_openBlock(), _createBlock(_component_v_card_text, { key: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_divider, { class: "mb-3" }),
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.offer.cancellationPolicy), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.offer.comment)
          ? (_openBlock(), _createBlock(_component_v_card_text, { key: 3 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_divider, { class: "mb-3" }),
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.offer.comment), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showConfirm,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showConfirm) = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(`Ajánlat elfogadása – ${_ctx.offer.items[0]?.accommodation}`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode("Biztosan elfogadja az ajánlatot?")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "",
                  color: "grey",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showConfirm = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Mégse")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "success",
                  onClick: _ctx.confirmAccept
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Igen, elfogadom")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showDeclineConfirm,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showDeclineConfirm) = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(`Ajánlat elutasítása – ${_ctx.offer.items[0]?.accommodation}`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode("Biztosan elutasítja az ajánlatot? Ez a lépés nem vonható vissza, de a többi ajánlat továbbra is elfogadható marad.")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  text: "",
                  color: "grey",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDeclineConfirm = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Mégse")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  onClick: _ctx.confirmDecline
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Igen, elutasítom")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}